module.exports = __webpack_public_path__ + "img/Boy_020029.6dcaedfd.png";